import {
    resolveWorkPanelViewMode,
    WORK_PANEL_VIEW_MODE_DEFAULT,
} from "./workPanelViewMode.js";

const STORAGE_KEY = "kfu_work_panel_view_mode";

function readMap() {
    if (typeof localStorage === "undefined") {
        return {};
    }

    try {
        const raw = localStorage.getItem(STORAGE_KEY);

        if (!raw) {
            return {};
        }

        const parsed = JSON.parse(raw);

        return parsed && typeof parsed === "object" && !Array.isArray(parsed)
            ? parsed
            : {};
    } catch {
        return {};
    }
}

function writeMap(map) {
    if (typeof localStorage === "undefined") {
        return;
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(map ?? {}));
}

/**
 * @param {string|number|null|undefined} userProfileId
 * @returns {string|null}
 */
export function resolveWorkPanelViewModeProfileId(userProfileId) {
    if (userProfileId != null && userProfileId !== "") {
        return String(userProfileId);
    }

    if (typeof localStorage === "undefined") {
        return null;
    }

    try {
        const fromStorage = localStorage.getItem("kaamfu_profile_id");

        return fromStorage ? String(fromStorage) : null;
    } catch {
        return null;
    }
}

/**
 * @param {string|number|null|undefined} userProfileId
 * @returns {string|undefined} undefined when nothing stored for this profile
 */
export function readWorkPanelViewModeFromStorage(userProfileId) {
    const profile_id = resolveWorkPanelViewModeProfileId(userProfileId);

    if (!profile_id) {
        return undefined;
    }

    const map = readMap();

    if (!Object.prototype.hasOwnProperty.call(map, profile_id)) {
        return undefined;
    }

    return resolveWorkPanelViewMode(map[profile_id]);
}

/**
 * @param {string|number|null|undefined} userProfileId
 * @returns {typeof WORK_PANEL_VIEW_MODE_FULL | typeof WORK_PANEL_VIEW_MODE_PANEL}
 */
export function hydrateWorkPanelViewMode(
    userProfileId,
    defaultMode = WORK_PANEL_VIEW_MODE_DEFAULT,
) {
    const stored = readWorkPanelViewModeFromStorage(userProfileId);

    if (stored !== undefined) {
        return stored;
    }

    return resolveWorkPanelViewMode(defaultMode);
}

/**
 * @param {string|number|null|undefined} userProfileId
 * @param {string|null|undefined} mode
 */
export function writeWorkPanelViewModeToStorage(userProfileId, mode) {
    const profile_id = resolveWorkPanelViewModeProfileId(userProfileId);

    if (!profile_id) {
        return;
    }

    const map = readMap();
    map[profile_id] = resolveWorkPanelViewMode(mode);
    writeMap(map);
}
